import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";
import { ORDERS_API } from "../../../../Utilities/APIs/APIs";

import CRUDTable from "../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable";
import CRUDTableHeader from "../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableRow from "../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow";
import ShortTextCell from "../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import CRUDButton from "../../../Partials/Layouts/CRUDs/CRUDButtons/CRUDButton";

import Modal from "../../../Partials/Elements/Modal/Modal";
import CancelOrderItem from "./CancelOrderItem";
import ChangeOrderedProductStatus from "./ChangeOrderedProductStatus";
import { RiCloseCircleLine, RiExchangeLine } from "react-icons/ri";
import AddProductToOrder from "./AddProductToOrder";

function OrderItemsFromOrders() {
  const axiosInstance = useAxiosInstance();
  const { orderID } = useParams();

  const [orderItems, setOrderItems] = useState(null);
  const [order, setOrder] = useState(null);

  const [showCancelOrderItem, setShowCancelOrderItem] = useState(false);
  const [showChangeOrderedProductStatus, setShowChangeOrderedProductStatus] =
    useState(false);

  const [targetID, setTargetID] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const [toggleFetch, setToggleFetch] = useState(false);

  const screenHeaerRef = useRef();
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);
  const [showAddProductToOrder, setShowAddProductToOrder] = useState(false);

  useEffect(() => {
    if (screenHeaerRef.current) {
      setScreenHeaderHeight(screenHeaerRef.current.clientHeight);
    }
  }, [screenHeaerRef]);

  useEffect(() => {
    async function fetchAndSetOrderItems() {
      const { data } = await axiosInstance.get(
        ORDERS_API + "orderItemsFromOrder/" + orderID
      );
      setOrderItems(data.orderItems);
      setOrder(data.order);
    }

    if (orderID) {
      fetchAndSetOrderItems();
    }
  }, [axiosInstance, orderID, toggleFetch]);

  function triggerFetch() {
    setToggleFetch((prev) => !prev);
  }

  const orderStatus = order?.orderStatus || "";

function getPrettyStatus(orderItem) {
  const status = orderItem?.itemStatus || "pending";

  const qty = Number(orderItem?.quantity || 0);
  let cancelled = Number(orderItem?.cancelQuantity || 0);

  if (!cancelled && orderItem?.isCancelled) {
    cancelled = qty;
  }

  const hasPartialCancel = cancelled > 0 && cancelled < qty;

  let baseStatus = "Pending";

  switch (status) {
    case "dispatchedInHouse":
      baseStatus = "Dispatched (InHouse)";
      break;
    case "dispatchedCourier":
      baseStatus = "Dispatched (Courier)";
      break;
    case "delivered":
      baseStatus = "Delivered";
      break;
    case "deliveredUnpaid":
      baseStatus = "Delivered (Unpaid)";
      break;
    case "canceled":
      baseStatus = "Canceled";
      break;
    case "refunded":
      baseStatus = "Refunded";
      break;
    case "exchanged":
      baseStatus = "Exchanged";
      break;
    default:
      baseStatus = "Pending";
  }

  if (hasPartialCancel) {
    return `${baseStatus} (Canceled ${cancelled} out of ${qty})`;
  }

  return baseStatus;
}

  return (
    <>
      <div className="screen_header" ref={screenHeaerRef}>
        <h1 className="screen_heading">
          Products ({orderItems?.length || 0} in total)
        </h1>

        <button
          className="create_btn" style={{backgroundColor: "#F1652F", padding: "10px", color: "white", fontStyle: "bold", fontSize: "14px"}}
          onClick={() => setShowAddProductToOrder(true)}
        >
          Add Product
        </button>
      </div>

      <CRUDTable>
        <CRUDTableHeader>
          <CRUDth th="Item" />
          <CRUDth th="Size" />
          <CRUDth th="Quantity" />
          <CRUDth th="Unit Price" />
          <CRUDth th="Total" />
          <CRUDth th="Status" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>

        <tbody style={{ overflowY: "initial" }}>
          {orderItems?.map((orderItem) => {
            const qty = Number(orderItem.quantity || 0);
            let cancelled = Number(orderItem.cancelQuantity || 0);

            if (!cancelled && orderItem.isCancelled) {
              cancelled = qty;
            }

            const remainingCancelable = Math.max(0, qty - cancelled);
            const allowCancel =
              remainingCancelable > 0 &&
              !["canceled", "refunded", "exchanged"].includes(orderStatus);

            const lineStatus = orderItem?.itemStatus || "pending";
            const finalStatuses = ["canceled", "refunded", "exchanged"];
            const allowStatusChange = !finalStatuses.includes(lineStatus);

            return (
              <CRUDTableRow key={orderItem._id}>
                <ShortTextCell text={orderItem?.item?.name} />
                <ShortTextCell text={orderItem?.size?.name} />
                <ShortTextCell text={qty} />
                <ShortTextCell text={orderItem?.unitPrice} />
                <ShortTextCell text={orderItem?.totalPrice} />
                <ShortTextCell text={getPrettyStatus(orderItem)} />

                <td>
                  <div className="action_buttons_wrapper">
                    <div className="action_buttons">

                      {allowStatusChange && (
                        <CRUDButton
                          handleClick={() => {
                            setShowChangeOrderedProductStatus(true);
                            setTargetID(orderItem._id);
                            setSelectedItem(orderItem);
                          }}
                          tooltip={"Change Ordered Product Status"}
                        >
                          <RiExchangeLine />
                        </CRUDButton>
                      )}

                      {allowCancel && (
                        <CRUDButton
                          handleClick={() => {
                            setShowCancelOrderItem(true);
                            setTargetID(orderItem._id);
                            setSelectedItem(orderItem);
                          }}
                          tooltip={"Cancel Order Item"}
                        >
                          <RiCloseCircleLine />
                        </CRUDButton>
                      )}

                    </div>
                    
                  </div>
                </td>
              </CRUDTableRow>
            );
          })}
        </tbody>
      </CRUDTable>

      {showCancelOrderItem && (
        <Modal
          extraClass={"small"}
          modalHeading={`Cancel Order Item`}
          setShowModalContent={setShowCancelOrderItem}
        >
          <CancelOrderItem
            targetID={targetID}
            orderID={orderID}
            orderStatus={orderStatus}
            orderItem={selectedItem}
            setShowCancelOrderItem={setShowCancelOrderItem}
            triggerFetch={triggerFetch}
          />
        </Modal>
      )}

      {showChangeOrderedProductStatus && (
        <Modal
          extraClass={"small"}
          modalHeading={`Change Ordered Product Status`}
          setShowModalContent={setShowChangeOrderedProductStatus}
        >
          <ChangeOrderedProductStatus
            targetID={targetID}
            orderID={orderID}
            orderItem={selectedItem}
            setShowChangeOrderedProductStatus={setShowChangeOrderedProductStatus}
            triggerFetch={triggerFetch}
          />
        </Modal>
      )}

      {showAddProductToOrder && (
        <Modal
          extraClass={"small"}
          modalHeading={`Add Product To Order`}
          setShowModalContent={setShowAddProductToOrder}
        >
          <AddProductToOrder
            orderID={orderID}
            setShowAddProductToOrder={setShowAddProductToOrder}
            triggerFetch={triggerFetch}
          />
        </Modal>
      )}
      
    </>
  );
}

export default OrderItemsFromOrders;